var _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMisson(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Icons",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "-3.2 -3.2 38.40 38.40",
    xmlSpace: "preserve",
    width: "256px",
    height: "256px",
    fill: "#000000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0,
    transform: "translate(1.4399999999999995,1.4399999999999995), scale(0.91)"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "translate(-3.2, -3.2), scale(1.2)",
    d: "M16,31.43812581524253C19.785993131541826,32.28411078848924,23.519603098673496,28.825292902546927,25.47450014454292,25.47450014454292C27.130954442912547,22.635253403304404,25.380907115931755,19.265763715721384,25.00680785998702,16C24.704285988365093,13.35908335593973,25.45285700339508,10.305218897372924,23.526952403261138,8.473047596738864C21.619220216335776,6.658164262467059,18.587175746493703,7.92120956644028,16,7.431551245972514C12.147581109325808,6.702428392102867,8.05641815280788,2.555164390722501,4.95876463890459,4.958764638904588C1.93599136671628,7.304262143586719,3.875520319451969,12.330104424348974,4.957362851127982,15.999999999999998C5.725473778851371,18.60563512038502,8.405958898455603,19.804195469099604,9.986347281752494,22.013652718247503C12.240143845322095,25.164566258307357,12.219240570366445,30.59331031933374,16,31.43812581524253",
    fill: "#9a702d",
    strokeWidth: 0
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, " .st0{fill:none;stroke:#000000;stroke-width:2;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;} "), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 16,
    y1: 16,
    x2: 22,
    y2: 10
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "30,6 26,6 26,2 22,6 22,10 26,10 "
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 16,
    cy: 16,
    r: 6
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M27,9c1.3,2,2,4.4,2,7c0,7.2-5.8,13-13,13S3,23.2,3,16S8.8,3,16,3c2.6,0,5,0.7,7,2"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMisson);
export default __webpack_public_path__ + "static/media/misson.feb4ef6c3b8c1c7601f3b4a98d992a93.svg";
export { ForwardRef as ReactComponent };